import React from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Alert from "@mui/lab/Alert";
import Button from "@mui/material/Button";
import { Snackbar } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import TopBar from "./components/nav/top-bar";
import Recipes from "./components/recipe/recipes";
import Recipe from "./components/recipe/recipe";
import Planner from "./components/planner/planner";
import Meal from "./components/planner/meal";
import ShoppingList from "./components/shopping/shopping-list";
import Shopping from "./components/shopping/shopping";
import Login from "./views/login";
import Providers from "./providers";
import VerifiedRoute from "./routes/verified-route";
import SignUp from "./views/signup";
import NoAuthRoute from "./routes/no-auth-route";
import ROUTES from "./routes/routes";
import Confirm from "./views/confirm";
import UnverifiedRoute from "./routes/unverified-route";
import BottomBar from "./components/nav/bottom-bar";
import Home from "./components/home/home";
import ScrollToTop from "./components/nav/scroll-to-top";
import SetUp from "./views/setup";
import SetUpRoute from "./routes/setup-route";
import Initializer from "./initializer";
import Friends from "./components/friends/friends";
import Friend from "./components/friends/friend";
import Settings from "./views/settings";
import { useServiceWorker } from "./context-providers/use-service-worker";
import "animate.css";
import theme from "./theme";

const useStyles = makeStyles()(() => ({
  app: {
    minHeight: "100vh",
  },
  appContent: {
    minHeight: "calc(100vh - 144px)",
  },
}));

function App() {
  const { isUpdateAvailable, updateAssets } = useServiceWorker();
  const { classes } = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ScrollToTop />
        <Providers>
          <div className={classes.app}>
            <TopBar />
            <Initializer>
              <Box className={classes.appContent}>
                <Routes>
                  <Route
                    path={ROUTES.HOME}
                    element={
                      <VerifiedRoute>
                        <Home />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.RECIPES}
                    element={
                      <VerifiedRoute>
                        <Recipes />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.PLANNER}
                    element={
                      <VerifiedRoute>
                        <Planner />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.SHOPPING}
                    element={
                      <VerifiedRoute>
                        <Shopping />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.FRIENDS}
                    element={
                      <VerifiedRoute>
                        <Friends />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.SETTINGS}
                    element={
                      <VerifiedRoute>
                        <Settings />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path="/shopping/:shoppingListId"
                    element={
                      <VerifiedRoute>
                        <ShoppingList />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path="/recipes/:recipeId"
                    element={
                      <VerifiedRoute>
                        <Recipe />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path="/planner/:mealId"
                    element={
                      <VerifiedRoute>
                        <Meal />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path="/friends/:username/recipes/:recipeId"
                    element={
                      <VerifiedRoute>
                        <Recipe />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path="/friends/:username"
                    element={
                      <VerifiedRoute>
                        <Friend />
                      </VerifiedRoute>
                    }
                  />
                  <Route
                    path={ROUTES.LOGIN}
                    element={
                      <NoAuthRoute>
                        <Login />
                      </NoAuthRoute>
                    }
                  />
                  <Route
                    path={ROUTES.SIGNUP}
                    element={
                      <NoAuthRoute>
                        <SignUp />
                      </NoAuthRoute>
                    }
                  />
                  <Route
                    path={ROUTES.CONFIRM}
                    element={
                      <UnverifiedRoute>
                        <Confirm />
                      </UnverifiedRoute>
                    }
                  />
                  <Route
                    path="/setup"
                    element={
                      <SetUpRoute>
                        <SetUp />
                      </SetUpRoute>
                    }
                  />
                  <Route
                    path="*"
                    element={<Navigate to={ROUTES.LOGIN} replace />}
                  />
                </Routes>
              </Box>
              <BottomBar />
              {isUpdateAvailable && (
                <Snackbar open>
                  <Alert
                    variant="filled"
                    severity="info"
                    action={
                      <Button
                        color="secondary"
                        size="small"
                        onClick={updateAssets}
                      >
                        RELOAD
                      </Button>
                    }
                  >
                    Cook&apos;d has been updated!
                  </Alert>
                </Snackbar>
              )}
            </Initializer>
            <div id="custom-prompt" />
          </div>
        </Providers>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
